import { render, staticRenderFns } from "./FindByCPF.vue?vue&type=template&id=12f75a50"
import script from "./FindByCPF.vue?vue&type=script&lang=js"
export * from "./FindByCPF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports